import { render, staticRenderFns } from "./FileUploadComponent.vue?vue&type=template&id=53d853d8&scoped=true&"
import script from "./FileUploadComponent.vue?vue&type=script&lang=js&"
export * from "./FileUploadComponent.vue?vue&type=script&lang=js&"
import style0 from "./FileUploadComponent.vue?vue&type=style&index=0&id=53d853d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d853d8",
  null
  
)

export default component.exports